__turbopack_context__.v({
  "name": "_4_GsLa_name",
  "row": "_4_GsLa_row",
});
